import { createReducer, on } from '@ngrx/store';
import * as GatewayActions from './gateway.actions';
import { Gateway } from './gateway.models';

// ----------------------------------------------------------------------
// @ States
// ----------------------------------------------------------------------

export interface GatewaysState {
    gateways: Gateway[];
    gateway: Gateway | null;
    isLoading: boolean;
    error: string | null;
}

// ----------------------------------------------------------------------
// @ Initial States
// ----------------------------------------------------------------------

export const initialGatewaysState: GatewaysState = {
    gateways: [],
    gateway: null,
    isLoading: false,
    error: null,
};

// ----------------------------------------------------------------------
// @ Reducers
// ----------------------------------------------------------------------

// All Gateways Reducer
export const gatewaysReducer = createReducer(
    initialGatewaysState,

    // On Load Gateways
    on(GatewayActions.loadGateways, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(GatewayActions.loadGatewaysSuccess, (state, { gateways }) => ({
        ...state,
        isLoading: false,
        gateways: gateways,
    })),
    on(GatewayActions.loadGatewaysFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Gateways by Production
    on(GatewayActions.loadGatewaysByProduction, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(
        GatewayActions.loadGatewaysByProductionSuccess,
        (state, { gateways }) => ({
            ...state,
            isLoading: false,
            gateways: gateways,
        })
    ),
    on(GatewayActions.loadGatewaysByProductionFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Load Single Gateway
    on(GatewayActions.loadGateway, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(GatewayActions.loadGatewaySuccess, (state, { gateway }) => ({
        ...state,
        isLoading: false,
        gateway: gateway,
    })),
    on(GatewayActions.loadGatewayFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Create
    on(GatewayActions.createGateway, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(GatewayActions.createGatewaySuccess, (state, { gateway }) => ({
        ...state,
        isLoading: false,
        gateways: [...(state.gateways || []), gateway],
    })),
    on(GatewayActions.createGatewayFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Update
    on(GatewayActions.updateGateway, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(GatewayActions.updateGatewaySuccess, (state, { gateway }) => ({
        ...state,
        isLoading: false,
        gateways: state.gateways.map((g) =>
            g.id === gateway.id ? gateway : g
        ),
    })),
    on(GatewayActions.updateGatewayFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    })),

    // On Delete
    on(GatewayActions.deleteGateway, (state) => ({
        ...state,
        isLoading: true,
    })),
    on(GatewayActions.deleteGatewaySuccess, (state, { id }) => ({
        ...state,
        isLoading: false,
        gateways: state.gateways.filter((g) => g.id !== id),
    })),
    on(GatewayActions.deleteGatewayFailure, (state, { error }) => ({
        ...state,
        isLoading: false,
        error: error,
    }))
);
